import { render } from "./UpdateVirtualMembershipCard.vue?vue&type=template&id=77acd8bc&scoped=true"
import script from "./UpdateVirtualMembershipCard.vue?vue&type=script&lang=js"
export * from "./UpdateVirtualMembershipCard.vue?vue&type=script&lang=js"

import "./UpdateVirtualMembershipCard.vue?vue&type=style&index=0&id=77acd8bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77acd8bc"]])

export default __exports__